import { createFileRoute, Link } from "@tanstack/react-router";

import { CookiePreferencesButton } from "@/components/CookieBanner";

export const Route = createFileRoute("/confidentialite")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:type", content: "website" },
      { title: "Politique de confidentialité — Mathys Gautier" },
      {
        name: "description",
        content:
          "Données personnelles, stockages nécessaires, mesure d’audience avec consentement, contenus tiers et droits RGPD sur le site de Mathys Gautier.",
      },
      { property: "og:title", content: "Politique de confidentialité — Mathys Gautier" },
      {
        property: "og:description",
        content:
          "Données personnelles, stockages nécessaires, mesure d’audience avec consentement, contenus tiers et droits RGPD sur le site de Mathys Gautier.",
      },
      { name: "robots", content: "index, follow" },
    ],
  }),
  component: Confidentialite,
});

function Confidentialite() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <p className="eyebrow">RGPD</p>
      <h1 className="mt-12 font-serif text-5xl">Politique de confidentialité</h1>
      <p className="mb-20 max-w-2xl text-sm leading-relaxed text-muted-foreground">
        Ce site est conçu pour fonctionner avec le minimum de données personnelles : aucun compte,
        aucune publicité, aucun traceur publicitaire, aucun service d’analyse tiers.
      </p>

      <div className="space-y-10 text-sm leading-relaxed">
        <section>
          <h2 className="font-serif text-2xl">Responsable du traitement</h2>
          <p className="mt-3 text-muted-foreground">
            Mathys Gautier — <a href="mailto:mathys.gautier@sciencespo.fr">mathys.gautier@sciencespo.fr</a>. Voir
            également les <Link to="/mentions-legales">mentions légales</Link>.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Stockages strictement nécessaires</h2>
          <p className="mt-3 text-muted-foreground">
            Conservés dans votre navigateur (aucun envoi à un serveur), sans consentement requis car
            indispensables au service demandé :
          </p>
          <ul className="mt-3 list-disc space-y-1 pl-5 text-muted-foreground">
            <li>préférence de thème clair/sombre ;</li>
            <li>mémorisation de votre choix de consentement (13 mois) ;</li>
            <li>cache de navigation des contenus déjà consultés, pour accélérer l’affichage ;</li>
            <li>indicateur d’animation d’introduction déjà vue (durée de la session).</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Mesure d’audience (soumise à consentement)</h2>
          <p className="mt-3 text-muted-foreground">
            Si vous l’acceptez, un simple compteur interne enregistre le fait qu’un contenu a été
            consulté (type et identifiant du contenu, date). Aucune adresse IP, aucun identifiant de
            visiteur, aucun profil n’est enregistré, et les données ne sont jamais transmises à un
            tiers. Base légale : votre consentement, révocable à tout moment.
          </p>
          <div className="mt-4">
            <CookiePreferencesButton className="rounded-full border border-foreground px-5 py-2 text-sm transition-colors hover:bg-foreground hover:text-paper" />
          </div>
        </section>



        <section>
          <h2 className="font-serif text-2xl">Contenus tiers intégrés</h2>
          <p className="mt-3 text-muted-foreground">
            Certaines pages intègrent des contenus hébergés par Instagram (Meta), Datawrapper ou des
            plateformes de podcast. Leur affichage peut entraîner des dépôts de cookies par ces
            services, régis par leurs propres politiques.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Formulaire de contact</h2>
          <p className="mt-3 text-muted-foreground">
            La prise de contact se fait par courriel : votre message est envoyé depuis votre propre
            messagerie et n’est enregistré sur aucun serveur de ce site.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Hébergement et transferts hors UE</h2>
          <p className="mt-3 text-muted-foreground">
            Le site est distribué par Cloudflare, Inc. (États-Unis) via son réseau mondial ; la base
            de données et les fichiers médias sont hébergés dans l’Union européenne. Les éventuels
            transferts hors UE sont encadrés par les clauses contractuelles types de la Commission
            européenne et par le Data Privacy Framework.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Vos droits</h2>
          <p className="mt-3 text-muted-foreground">
            Vous disposez des droits d’accès, de rectification, d’effacement, de limitation,
            d’opposition et de portabilité. Compte tenu de l’absence d’identifiant de visiteur, les
            données de mesure d’audience ne permettent pas de vous identifier. Pour toute demande :{" "}
            <a href="mailto:mathys.gautier@sciencespo.fr">mathys.gautier@sciencespo.fr</a>. Vous
            pouvez également saisir la CNIL (
            <a href="https://www.cnil.fr" target="_blank" rel="noreferrer noopener">
              cnil.fr
            </a>
            ).
          </p>
        </section>
      </div>
    </div>
  );
}
